

import clsx from "clsx"
import { signIn } from "next-auth/react"
import { useState } from "react"
import { useForm } from "react-hook-form"
import toast from "react-hot-toast"
import { mutate } from "swr"
import styles from "./auth.module.scss"
import FormInput from "./formInput"

export default function Component({ setForm, isMobileApp }: { setForm: (form: string) => void, isMobileApp?: boolean }) {
    const { register, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm<{ email: string, password: string }>()
    const [showPassword, setShowPassword] = useState(false)

    const onSubmit = handleSubmit(async v => {
        return signIn("credentials", { ...v, redirect: false })
            .then(r => {
                if (!r || r.error) throw new Error("Κάτι πήγε στραβά. Παρακαλώ ελέγξτε τα στοιχεία σας.")
                mutate("/api/auth/session")
                setForm("")
            })
            .catch(e => {
                toast.error(e.message)
                setError("email", { type: "custom", message: "Επαληθεύστε το e-mail" })
                setError("password", { type: "custom", message: "Επαληθεύστε τον κωδικό" })
            })
    })

    return (
        <div className={styles.signIn}>
            <form onSubmit={onSubmit}>
                <FormInput
                    type="email"
                    placeholder="Email"
                    error={errors.email?.message}
                    className={styles.inputContainerCustomStyle}
                    {...register("email", { required: "Αυτό το πεδίο είναι υποχρεωτικό" })}
                />
                <FormInput
                    type={showPassword ? "text" : "password"}
                    placeholder="Κωδικός"
                    className={styles.inputContainerCustomStyle}
                    error={errors.password?.message}
                    {...register("password", { required: "Αυτό το πεδίο είναι υποχρεωτικό" })}
                    addon={(
                        <button className={styles.showPass} type="button" onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <i className="svgIcon"
                            ><svg><use xlinkHref="#IconEyeSlash"></use></svg></i> : <i className="svgIcon"
                            ><svg><use xlinkHref="#IconEye"></use></svg></i>}
                        </button>
                    )}
                />
                <button className={clsx("cmnBtn", styles.signInButton)} disabled={isSubmitting}>Συνδεθειτε</button>
            </form>

            <div className={styles.actions}>
                <button className={styles.forgotPass} onClick={() => setForm("forgotPassword")}>Ξέχασα τον κωδικό μου</button>

                {!isMobileApp && <button onClick={() => signIn("google", { callbackUrl: `${window.location.pathname}?isSignedIn` })} className={styles.alternative}>
                    <div className={styles.googleLogo}>
                        <i className="svgIcon">
                            <svg>
                                <use xlinkHref="#IconGoogle"></use>
                            </svg>
                        </i>
                    </div>
                    <span className={styles.altTitle}>Συνδεση με λογαριασμο google</span>

                </button>}

                <div className={styles.signup}>
                    Νέο μέλος;
                    <button onClick={() => setForm("signUp")}>Εγγραφείτε τώρα!</button>
                </div>

                <div className={styles.contactUs}>
                    <a href="/contact" onClick={() => setForm("")}>Επικοινωνήστε μαζί μας</a>
                    <span> για σχόλια, παρατηρήσεις &amp; τεχνικά προβλήματα σχετικά με τον λογαριασμό σας.</span>
                </div>
            </div>
        </div>
    )
}